<template>
  <div>
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons >
          <!-- <ion-back-button v-if="!editReservationPage" default-href="#" button @click="goBack"></ion-back-button> -->
          <ion-back-button v-if="!editReservationPage" default-href="#" button @click="navigatePreviousPage"></ion-back-button>
          <ion-back-button v-if="editReservationPage" default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title class="fontRoboto">Select Type</ion-title>
          <ion-icon :icon="homeSharp"  class="ion-margin ios" @click="homePage"></ion-icon>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar class="header-toolbar">
        <ion-grid class="title-wrapper ion-no-padding">
          <ion-row>
            <ion-col size-md="8">
              <ion-toolbar class="mobile-header-toolbar">
                <ion-buttons v-slot: start>
                  <!-- <ion-back-button v-if="!editReservationPage" default-href="#" button @click="goBack"></ion-back-button> -->
                  <ion-back-button v-if="!editReservationPage" default-href="#" button @click="navigatePreviousPage"></ion-back-button>
                  <ion-back-button v-if="editReservationPage" default-href="#" @click="navigatePreviousPage"></ion-back-button>
                </ion-buttons>
                <ion-title class="fontRoboto">New Reservation/Select Type</ion-title>
              </ion-toolbar>
            </ion-col>
            <ion-col size-md="4" size-xs="8" class="ion-no-padding">
              <div class="price-tag">
                <p class="ion-no-margin">Available Bal</p>
                <p class="ion-no-margin">&#8377; {{amountDetails.clearBalance}}</p>
              </div>
              <div class="price-tag">
                <p class="ion-no-margin">Current Bal</p>
                <p class="ion-no-margin">&#8377; {{amountDetails.totalBalance}}</p>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-toolbar>
    </ion-header>
    <ion-content class="slot-page">
      <ion-grid class="rectangle rp-mobile" >
        <ion-row>
          <ion-col>
            <div class="price-tag">
              <p class="ion-no-margin">Available Bal</p>
              <p class="ion-no-margin">&#8377; {{amountDetails.clearBalance}}</p>
            </div>
          </ion-col>
          <ion-col>
            <ion-button shape="round" fill="outline" color="success" class="add-amount" @click="addAmount">Add Amount</ion-button>
          </ion-col>
      </ion-row>
      </ion-grid>
      <div class="slot-booking-wrapper">
        <ion-grid class="paddingZero">
          <ion-row>
            <ion-col size="12" size-md="12" size-xs="12" class="paddingZero">
              <dl class="accordion box" role="presentation">
                <div id="groupId-4" class="accordion-item" :class="{'is-active': abActive,'disabledChargeType' : this.slotBookingDisplayType.abType == 'true' ? true : false}">
                  <dt class="accordion-item-title">
                    <button @click="toggle" class="accordion-item-trigger">
                      <h4 class="accordion-item-title-text">Amount Based</h4>
                      <span class="accordion-item-trigger-icon"></span>
                    </button>
                  </dt>
                  <transition
                    name="accordion-item"
                    @enter="startTransition"
                    @after-enter="endTransition"
                    @before-leave="startTransition"
                    @after-leave="endTransition"
                  >
                    <dd v-if="abActive" class="accordion-item-details">
                      <div class="accordion-item-details-inner">
                        <div class="cb-slot">
                          <div class="tb-header-sec">
                            <div class="tb-header-price ion-float-right">
                              <p class="ion-no-margin fontRobotoBold title">Estimated Cost</p>
                              <p
                                class="ion-no-margin fontRobotoMedium price"
                                v-if="abSlotEstimateValue"
                              >₹ {{estimatedCost}}</p>
                            </div>
                          </div>
                          <div class="clearFix calander-sec cb-based">
                            <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div class="dp-label">
                                <p class="ion-no-margin">Start Date</p>
                              </div>
                              <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="abtodayDate" @update:model-value="abSlotEstimateCost(abtodayDate, 'abtodayDate')" :enable-time-picker="false" :format="customeDateFormat"/>
                            </div>

                            <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div  class="dp-label">
                                <span class="fontRobotoMedium">Start Time</span>
                               
                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="abSelectedTime" @update:model-value="abSlotEstimateCost(abSelectedTime,'abstartTime')" time-picker placeholder="Select Time" />
                                
                              </div>
                            </div>

                            <!-- below code is commented on 13-05-2025 as per siva sir request end date and time is hided -->
                            <!-- <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div class="dp-label">
                                <p class="ion-no-margin">End Date</p>
                              </div>
                              <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="abEndDate" :enable-time-picker="false" :format="customeDateFormat"/>
                            </div> -->
                            <!-- <div class="time-slot-sec">
                              <div class="st-slot ion-float-left width50 disabledOption">
                                <span class="fontRobotoMedium">Start Time</span>
                               
                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="abSelectedTime" @update:model-value="abSlotEstimateCost(abSelectedTime,'abstartTime')" time-picker placeholder="Select Time" />
                                
                              </div> -->
                              <!-- below code is commented on 13-05-2025 as per siva sir request end date and time is hided -->
                              <!-- <div class="et-slot ion-float-right width50 disabledOption">
                                <span class="fontRobotoMedium">End Time</span>
                                
                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="abendTime" time-picker placeholder="Select Time" />
                                
                              </div> -->
                            <!-- </div> -->
                            <div class="capacity-sec clearFix" v-if="!disableChargeType">
                              <p class="ion-no-margin fontRobotoMedium">Amount To Charge</p>
                              <input
                                class="fontRobotoMedium"
                                maxlength="6"
                                @focus="abAmountFlag = false"
                                v-on:blur="abSlotEstimateCost($event.target.value, 'abAmount')"
                                v-model="abAmount"
                                type="number"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </dd>
                  </transition>
                </div>
                <div id="groupId-3" class="accordion-item" :class="{'is-active': ubActive, 'disabledChargeType' : this.slotBookingDisplayType.ubType == 'true' ? true : disableChargeType}">
                  <dt class="accordion-item-title">
                    <button @click="toggle" class="accordion-item-trigger">
                      <h4 class="accordion-item-title-text">Unit Based</h4>
                      <span class="accordion-item-trigger-icon"></span>
                    </button>
                  </dt>
                  <transition
                    name="accordion-item"
                    @enter="startTransition"
                    @after-enter="endTransition"
                    @before-leave="startTransition"
                    @after-leave="endTransition"
                  >
                    <dd v-if="ubActive" class="accordion-item-details">
                      <div class="accordion-item-details-inner">
                        <div class="cb-slot">
                          <div class="tb-header-sec">
                            <div class="tb-header-price ion-float-right">
                              <p class="ion-no-margin fontRobotoBold title">Estimated Cost</p>
                              <p
                                class="ion-no-margin fontRobotoMedium price"
                                v-if="ubSlotEstimateValue"
                              >₹ {{estimatedCost}}</p>
                            </div>
                          </div>
                          <div class="clearFix calander-sec cb-based">
                            <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div class="dp-label">
                                <p class="ion-no-margin">Start Date</p>
                              </div>
                              
                              <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="ubtodayDate" @update:model-value="ubSlotEstimateCost(ubtodayDate, 'ubtodayDate')" :enable-time-picker="false" :format="customeDateFormat"/>
                            </div>
                            <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div  class="dp-label">
                                <span class="fontRobotoMedium">Start Time</span>
                               
                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="ubSelectedTime" @update:model-value="ubSlotEstimateCost(ubSelectedTime,'ubstartTime')" time-picker placeholder="Select Time" />
                                
                              </div>
                            </div>
                            <!-- below code is commented on 13-05-2025 as per siva sir request end date and time is hided -->
                            <!-- <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div class="dp-label">
                                <p class="ion-no-margin">End Date</p>
                              </div>
                              <VueDatePicker hide-input-icon v-model="ubEndDate" :clearable="false" :enable-time-picker="false" :format="customeDateFormat"/>
                            </div> -->
                            <!-- <div class="time-slot-sec">
                              <div class="st-slot ion-float-left width50 disabledOption">
                                <span class="fontRobotoMedium">Start Time</span>
                               
                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="ubSelectedTime" @update:model-value="ubSlotEstimateCost(ubSelectedTime,'ubstartTime')" time-picker placeholder="Select Time" />
                                
                              </div> -->
                              <!-- below code is commented on 13-05-2025 as per siva sir request end date and time is hided -->
                              <!-- <div class="et-slot ion-float-right width50 disabledOption">
                                <span class="fontRobotoMedium">End Time</span>
                              
                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="ubendTime" time-picker placeholder="Select Time" />
                                
                              </div> -->
                            <!-- </div> -->
                            <div class="capacity-sec clearFix">
                              <p class="ion-no-margin fontRobotoMedium">Units To Charge</p>
                              <input
                                class="fontRobotoMedium"
                                maxlength="6"
                                @focus="ubUnitFlag = false"
                                v-on:blur="ubSlotEstimateCost($event.target.value, 'ubUnit')"
                                v-model="ubUnit"
                                type="number"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </dd>
                  </transition>
                </div>
                <div id="groupId-1" class="accordion-item" :class="{'is-active': tbActive, 'disabledChargeType' : this.slotBookingDisplayType.tbType == 'true' ? true : disableChargeType}">
                  <dt class="accordion-item-title">
                    <button @click="toggle" class="accordion-item-trigger">
                      <h4 class="accordion-item-title-text">Time Based</h4>
                      <span class="accordion-item-trigger-icon"></span>
                    </button>
                  </dt>
                  <transition
                    name="accordion-item"
                    @enter="startTransition"
                    @after-enter="endTransition"
                    @before-leave="startTransition"
                    @after-leave="endTransition"
                  >
                    <dd v-if="tbActive" class="accordion-item-details">
                      <div class="accordion-item-details-inner">
                        <div class="tb-slot">
                          <div class="tb-header-sec">
                            <div class="tb-header-price ion-float-right">
                              <p class="ion-no-margin fontRobotoBold title">Estimated Cost</p>
                              <p
                                class="ion-no-margin fontRobotoMedium price"
                                v-if="tbSlotEstimateValue"
                              >₹ {{estimatedCost}}</p>
                            </div>
                          </div>
                          <div class="clearFix calander-sec"  v-if="!chargeNow">
                            <div class="date-picker-sec ion-float-left width50">
                              <div class="dp-label">
                                <p class="ion-no-margin">Start Date</p>
                              </div>
                              <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="tbtodayDate" @update:model-value="tbMSlotEstimateCost(tbtodayDate, 'tbtodayDate')" :enable-time-picker="false" :format="customeDateFormat" />
                            </div>
                            <div class="date-picker-sec ion-float-left width50">
                              <div class="dp-label">
                                <p class="ion-no-margin">Start Time</p>
                              </div>
                              <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="tbSelectedTime" @update:model-value="tbMSlotEstimateCost(tbSelectedTime,'tbstartTime')" time-picker placeholder="Select Time" />
                            </div>

                            <div class="time-slot-sec">
                              <div class="st-slot ion-float-left width50">
                                <span class="fontRobotoMedium">Duration Hour</span>
                                <input 
                                  maxlength="2"
                                  class="input-box"
                                  v-on:blur="tbMSlotEstimateCost($event.target.value, 'tbEndTimeHour')" 
                                  v-model="duration.hour"
                                  type="number">
                              </div>
                              <div class="et-slot ion-float-right width50">
                                <span class="fontRobotoMedium">Minutes</span>
                                <input maxlength="2"
                                  class="input-box" 
                                  v-on:blur="tbMSlotEstimateCost($event.target.value, 'tbEndTimeMinute')"
                                  v-model="duration.minutes"
                                  type="number">
                              </div>
                            </div>                   
                          </div>
                          <div class="clearFix calander-sec" v-if="chargeNow">
                            <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div class="dp-label">
                                <p class="ion-no-margin">Start Date</p>
                              </div>
                              <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="tbtodayDate" @update:model-value="tbMSlotEstimateCost(tbtodayDate, 'tbtodayDate')" :enable-time-picker="false" :format="customeDateFormat" />
                            </div>
                            <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div class="dp-label">
                                <p class="ion-no-margin">Start Time</p>
                              </div>
                              <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="tbSelectedTime" @update:model-value="tbMSlotEstimateCost(tbSelectedTime,'tbstartTime')" time-picker placeholder="Select Time" />
                            </div>

                            <div class="time-slot-sec">
                              <div class="st-slot ion-float-left width50">
                                <span class="fontRobotoMedium">Duration Hour</span>
                                <input 
                                  maxlength="2"
                                  class="input-box"
                                  v-on:blur="tbMSlotEstimateCost($event.target.value, 'tbEndTimeHour')" 
                                  v-model="duration.hour"
                                  type="number">
                              </div>
                              <div class="et-slot ion-float-right width50">
                                <span class="fontRobotoMedium">Minutes</span>
                                <input maxlength="2"
                                  class="input-box" 
                                  v-on:blur="tbMSlotEstimateCost($event.target.value, 'tbEndTimeMinute')"
                                  v-model="duration.minutes"
                                  type="number">
                              </div>
                            </div>                     
                          </div>
                        </div>
                      </div>
                    </dd>
                  </transition>
                </div>
                <div id="groupId-2" class="accordion-item" :class="{'is-active': cbActive, 'disabledChargeType' : this.slotBookingDisplayType.cbType == 'true' ? true : false}">
                  <dt class="accordion-item-title">
                    <button @click="toggle" class="accordion-item-trigger">
                      <h4 class="accordion-item-title-text">Capacity Based</h4>
                      <span class="accordion-item-trigger-icon"></span>
                    </button>
                  </dt>
                  <transition
                    name="accordion-item"
                    @enter="startTransition"
                    @after-enter="endTransition"
                    @before-leave="startTransition"
                    @after-leave="endTransition"
                  >
                    <dd v-if="cbActive" class="accordion-item-details">
                      <div class="accordion-item-details-inner">
                        <div class="cb-slot">
                          <div class="tb-header-sec">
                            <div class="tb-header-price ion-float-right">
                              <p class="ion-no-margin fontRobotoBold title">Estimated Cost</p>
                              <p
                                class="ion-no-margin fontRobotoMedium price"
                                v-if="cbSlotEstimateValue"
                              >₹ {{estimatedCost}}</p>
                            </div>
                          </div>
                          <div class="clearFix calander-sec cb-based">
                            
                            <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div class="dp-label">
                                <p class="ion-no-margin">Start Date</p>
                              </div>
                              
                              <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="cbtodayDate" @update:model-value="cbSlotEstimateCost(cbtodayDate, 'cbtodayDate')" :enable-time-picker="false" :format="customeDateFormat"/>
                            </div>
                            <div class="date-picker-sec ion-float-left width50 disabledOption">
                              <div class="dp-label">
                                <p class="ion-no-margin">End Date</p>
                              </div>
                              <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="cbEndDate" :enable-time-picker="false" :format="customeDateFormat"/>
                            </div>
                            <div class="time-slot-sec">
                              <div class="st-slot ion-float-left width50 disabledOption">
                                <span class="fontRobotoMedium">Start Time</span>
                                
                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="cbSelectedTime" @update:model-value="cbSlotEstimateCost(cbSelectedTime,'cbstartTime')" time-picker placeholder="Select Time" />
                                
                              </div>
                              <div class="et-slot ion-float-right width50 disabledOption">
                                <span class="fontRobotoMedium">End Time</span>
                                
                                <VueDatePicker hide-input-icon :teleport="true" :clearable="false" v-model="cbendTime" time-picker placeholder="Select Time" />
                                
                              </div>
                            </div>
                            <div class="capacity-sec clearFix">
                              <p class="ion-no-margin fontRobotoMedium">Current Battery Capacity</p>
                              <input
                                class="fontRobotoMedium"
                                maxlength="2"
                                @keypress="blockSpecialChar($event)"
                                @focus="cbCapacityFlag = false"
                                v-on:blur="cbSlotEstimateCost($event.target.value, 'cbCapacity')"
                                v-model="cbCapacity"
                                type="text"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </dd>
                  </transition>
                </div>
              </dl>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div class="rp-mobile"  v-if="enableNextSlot">
        <div>
          <p class="not-available">Charger is not available for selected duration</p>
        </div>
      </div>
      <div class="rp-mobile available-until" v-if="displayNextChargeTime">
        <ion-grid>
          <ion-row>
            <ion-col><p class="until-charger">Charger available Until</p></ion-col>
            <ion-col><p class="until-chargertime">{{changeDateFormat(nextChargeTime.startTime)}}</p></ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div class="footer-slot-grid rp-mobile" v-if="enableNextSlot">
        <div class="ft-slot-title ion-float-left">
          <p class="ion-no-margin fontRobotoBold">Next Available Slot</p>
          <p class="ion-no-margin fontRobotoBold">Estimated Cost</p>
        </div>
        <div class="ft-slot-price ion-float-right">
          <p class="ion-no-margin fontRoboto">
            
            <span>{{changeDateFormat(nextStartTime)}}</span>
            <span>{{changeDateFormat(nextEndTime)}}</span>
          </p>

          <p class="ion-no-margin fontRobotoMedium">₹ {{estimatedCost}}</p>
        </div>
      </div>
    </ion-content>
    <ion-footer class="footer-slot-wrapper">
      <div class="footer-slot-grid  rp-desktop" v-if="displayNextChargeTime">
        <div class="ft-slot-title ion-float-left">
          <p class="ion-no-margin fontRobotoBold">Charger available Until</p>
        </div>
        <div class="ft-slot-price ion-float-right">
          <p class="ion-no-margin fontRoboto">
            <span>{{changeDateFormat(nextChargeTime.startTime)}}</span>
          </p>
        </div>
      </div>
      <div class="footer-slot-grid rp-desktop" v-if="enableNextSlot">
        <div class="ft-slot-title ion-float-left">
          <p class="ion-no-margin fontRobotoBold">Next Available Slot</p>
          <p class="ion-no-margin fontRobotoBold">Estimated Cost</p>
        </div>
        <div class="ft-slot-price ion-float-right">
          <p
            class="ion-no-margin fontRoboto"
          >{{changeDateFormat(nextStartTime)}} - {{changeDateFormat(nextEndTime)}}</p>
          <p class="ion-no-margin fontRobotoMedium">₹ {{estimatedCost}}</p>
        </div>
      </div>
      <ion-button  v-if="!chargeNow"
        expand="full"
        @click="chargeNowConfirmPage()"
        v-bind:disabled="confirmPageNext"
        class="next-btn fontRobotoMedium"
      >
        Next
        <img src="/assets/images/station/109617.png" />
      </ion-button>
      <ion-button v-if="chargeNow"
        expand="full" 
        v-bind:disabled="chargeNowConfirmPageInd"
        @click="chargeNowConfirmPage()"
        class="next-btn fontRobotoMedium"
      >
        Next
        <img src="/assets/images/station/109617.png" />
      </ion-button>
    </ion-footer>
  </div>
</template>

<script>
import { defineComponent, toHandlers } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonGrid, IonRow, IonCol, IonContent, IonDatetime, IonButton, IonFooter, IonDatetimeButton, IonModal, IonIcon } from "@ionic/vue";

import { Coordiate } from "@/entity/location/corodinate";
import { EVCStationService } from "@/service/evcstation/stations.service";
import { EVCStationReservationService } from "@/service/evcstation/reservation.service";
import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { EVChargingReservationTypeCode } from '@/entity/station/reservation';
import VueDatePicker from '@vuepic/vue-datepicker';
import moment from 'moment';
import { WalletService } from "@/service/wallet/wallet.service";
import { homeSharp } from "ionicons/icons";

export default defineComponent ({
  name: 'slotBooking',
  components: {
    IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonGrid, IonRow, IonCol, IonContent, IonDatetime, IonButton, IonFooter, IonDatetimeButton, IonModal, VueDatePicker, IonIcon
  },
  data() {
    return {
      homeSharp,
      date: new Date(),
      time: new Date(),
      tbActive: false,
      cbActive: false,
      ubActive: false,
      abActive: true,

      timeBase: true,
      tbtodayDate: new Date(),
      tbEndDate: new Date(),
      minDate: new Date().toISOString(),
      tbstartTime: null,
      amountDetails: {
        totalBalance: "",
        clearBalance: "",
      },
      selectedChargerValue: "",
      tbendTime: null,
      cbtodayDate: new Date(),
      cbEndDate: null,
      cbstartTime: null,
      cbendTime: null,
      estimatedCost: null,
      nextStartTime: null,
      nextEndTime: null,
      cbCapacity: 20,
      confirmPageNext: true,
      selectedMarker: null,
      cbSlotEstimateValue: false,
      tbSlotEstimateValue: false,
      enableNextSlot: false,
      timeSlotBackDetails: null,
      editReservationPage: false,
      editReservationDetails: null,
      reservationId: null,
      cbCapacityFlag: true,
      previousPage: null,

      ubtodayDate: new Date(),
      ubEndDate: null,
      ubstartTime: null,
      ubendTime: null,
      ubUnit: 1,
      ubSlotEstimateValue: false,
      ubUnitFlag: true,

      abtodayDate: new Date(),
      abEndDate: null,
      abstartTime: null,
      abendTime: null,
      abAmount: 30,
      abSlotEstimateValue: false,
      abAmountFlag: true,
      duration: {
        "hour" : 0,
        "minutes" : 30
      },
      chargeNow : false,
      displayNextChargeTime: false,
      nextChargeTime: {},
      chargeNowConfirmPageInd: false,
      cusDate: new Date(),
      tbSelectedTime: null,
      cbSelectedTime: null,
      ubSelectedTime: null,
      abSelectedTime: null,
      disableChargeType: false,
      slotBookingDisplayChargeType : {
        "abType" : false,
        "ubType" : false,
        "tbType" : true,
        "cbType" : true,
      },
      slotBookingDisplayType: ''
    }
  },
  watch:{
    // cusDate(val) {
    // },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.previousPage = from.path;
      if (vm.previousPage == "/customer/evehicles/vehicle/U") {
        localStorage.setItem("previousPath", "unregistervehicle");
      }
    });
  },
  async mounted() {
    this.slotBookingDisplayType = await new EVCStationReservationService().getReservationType('QRCODE');

    // localStorage.removeItem("vehiclePath");
    new WalletService().summaryOfUser(new LocalStorage().user).then(data => {
      this.amountDetails = {
        totalBalance: data.totalBalance.toFixed(2),
        clearBalance: data.clearBalance.toFixed(2)
      };
      if(parseInt(this.amountDetails.clearBalance) != 0) {
        this.abAmount  = this.amountDetails.clearBalance;
        localStorage.setItem("amountDetails", JSON.stringify(this.amountDetails));
      }
    }).catch((error) => {
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    })
    setTimeout(() => {
      let selectedChargerValue = JSON.parse(
        localStorage.getItem("selectedChargerValue")
      );
      if(selectedChargerValue.rate.zeroTariff == 'Y'){
        this.disableChargeType = true;
      }
      this.editReservationPage = localStorage.getItem("editReservationPage");
      if (this.editReservationPage == null) {
        this.editReservationPage = false;
      }
      this.editReservationDetails = JSON.parse(
        localStorage.getItem("editReservationDetails")
      );
      
      this.timeSlotBackDetails = JSON.parse(localStorage.getItem("slotDetails"));
      let localDuration = JSON.parse(localStorage.getItem('duration'))
      if(localDuration) {
        this.duration.hour = localDuration.hour;
        this.duration.minutes = localDuration.minutes;
      }
      
      this.chargeNow = localStorage.getItem("chargeNow");
      if (this.editReservationPage) {
        
        this.onLoadEditDataSet();
      } else {
        if(this.chargeNow == 'true') {
          this.getAvailableTimeForChargeNow();
        } else {
          this.onLoadDataSet();
        }
      }
    }, 800)
    
  },
  methods: {
    homePage() {
      let userRole = localStorage.getItem("user.roleId")
      if(userRole == 2) {
        this.$router.push("/customer/reservation")
      }
    },
    customeDateFormat (date)  {
      let frmt = moment(date).format("DD/MMM/YYYY")
    return frmt;
    },
    updateDatepicker(){
    },
    handleDate(val){
    },
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    addAmount() {
      this.$router.push("/customer/ewallet")
    },
    toggle(event) {
      this.confirmPageNext = true;
      switch (event.currentTarget.parentElement.parentElement.id) {
        case "groupId-1":
          this.cbActive = false;
          this.ubActive = false;
          this.abActive = false;
          this.tbActive = true;
          // this.timeSlotEstimateCost("", "test");
          this.tbMSlotEstimateCost("", "test")
          break;
        case "groupId-2":
          this.tbActive = false;
          this.ubActive = false;
          this.abActive = false;
          this.cbActive = true;
          this.cbSlotEstimateCost("", "test");
          break;
        case "groupId-3":
          this.tbActive = false;
          this.cbActive = false;
          this.abActive = false;
          this.ubActive = true;
          this.ubSlotEstimateCost("", "test");
          break;
        case "groupId-4":
          this.tbActive = false;
          this.cbActive = false;
          this.ubActive = false;
          this.abActive = true;
          this.abSlotEstimateCost("", "test");
          break;
      }
    },
    startTransition(el) {
      el.style.height = el.scrollHeight + "px";
    },
    endTransition(el) {
      el.style.height = "";
    },

    onLoadDataSet() {
      this.reservationId = null;
      this.selectedMarker = JSON.parse(localStorage.getItem("selectedMarker"));
      this.selectedChargerValue = JSON.parse(
        localStorage.getItem("selectedChargerValue")
      );
      if (this.timeSlotBackDetails == null) {
        this.cbstartTime = new Date();
        this.cbstartTime.setHours(this.cbstartTime.getHours() + 0);
        this.tbendTime = new Date();
        this.tbendTime.setMinutes(this.tbendTime.getMinutes() + 30);

        this.tbstartTime = this.cbstartTime;
        // ****
        this.tbSelectedTime = this.tbstartTime;
        this.cbSelectedTime = this.cbstartTime;
        this.ubSelectedTime = this.ubstartTime;
        this.abSelectedTime = this.tbstartTime;
        // ****
        this.cbendTime = "-";
        this.tbEndDate = new Date(this.tbendTime);
        this.tbtodayDate = new Date(this.tbstartTime);

        this.ubstartTime = this.cbstartTime;
        this.ubendTime = "-";
        this.ubEndDate = new Date(this.tbendTime);
        this.ubtodayDate = new Date(this.ubstartTime);

        this.abstartTime = this.cbstartTime;
        this.abendTime = "-";
        this.abEndDate = new Date(this.tbendTime);
        this.abtodayDate = new Date(this.abstartTime);
        
        // this.timeSlotEstimateCost("", "test");
        this.abSlotEstimateCost("", "test");
      } else {
        this.tbstartTime = new Date(this.timeSlotBackDetails.poststartTime);
        this.tbSelectedTime = {
          "hours" : new Date(this.tbstartTime).getHours(),
          "minutes" : new Date(this.tbstartTime).getMinutes()
        }
        // this.tbendTime = new Date(this.timeSlotBackDetails.postendTime);
        // this.tbendTime = "-"

        this.duration  = JSON.parse(localStorage.getItem('duration'));
        let dt = new Date()
        if(this.duration.hour != 0) {
          if(this.duration.minutes != 0) {
            let dateWithMinute = new Date(new Date(this.tbstartTime).getTime() + this.duration.minutes* 60 * 1000);
            let dateWithHourMinute = new Date(dateWithMinute.getTime() + 60 * 60 * this.duration.hour * 1000);
            this.tbendTime = dateWithHourMinute;
          } else {
            let dateWithHour = new Date(new Date(this.tbstartTime).getTime() + 60 * 60 * this.duration.hour * 1000);
            this.tbendTime = dateWithHour;
          }
          
        } else {
          let dateWithMinute = new Date(new Date(this.tbstartTime).getTime() + this.duration.minutes* 60 * 1000);
          this.tbendTime = dateWithMinute;
        }


        this.tbtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
        this.tbEndDate = new Date(this.timeSlotBackDetails.selectedEndDate);
        this.cbstartTime = new Date(this.timeSlotBackDetails.poststartTime);
        this.cbendTime = "-";
        this.cbtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
        this.ubstartTime = new Date(this.timeSlotBackDetails.poststartTime);
        this.ubendTime = "-";
        this.ubtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
        this.abstartTime = new Date(this.timeSlotBackDetails.poststartTime);
        this.abendTime = "-";
        this.abtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
        if (this.timeSlotBackDetails.chargeType === EVChargingReservationTypeCode.ChargeForDuration) {
          this.tbstartTime = new Date(this.timeSlotBackDetails.poststartTime);
          this.tbendTime = new Date(this.timeSlotBackDetails.postendTime);
          this.tbtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
          this.tbEndDate = new Date(this.timeSlotBackDetails.selectedEndDate);
          // this.timeSlotEstimateCost("", "test");
          this.tbSelectedTime = this.tbstartTime;
          this.tbMSlotEstimateCost("", "test")
        } else if (this.timeSlotBackDetails.chargeType === EVChargingReservationTypeCode.ChargeUptoCapacity) {
          
          this.cbstartTime = new Date(this.timeSlotBackDetails.poststartTime);
          this.cbendTime = "-";
          this.cbtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
          this.cbCapacity = this.timeSlotBackDetails.percentNumber;
          this.cbSelectedTime = this.cbstartTime;
          this.cbSlotEstimateCost("", "test");
        } else if (this.timeSlotBackDetails.chargeType === EVChargingReservationTypeCode.ChargeForUnit) {
        
          this.ubstartTime = new Date(this.timeSlotBackDetails.poststartTime);
          this.ubendTime = "-";
          this.ubtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
          this.ubUnit = this.timeSlotBackDetails.unitNumber;
          this.ubSlotEstimateCost("", "test");
        } else if (this.timeSlotBackDetails.chargeType === EVChargingReservationTypeCode.ChargeForAmount) {
          
          this.abstartTime = new Date(this.timeSlotBackDetails.poststartTime);
          this.abendTime = "-";
          this.abtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
          this.abAmount = this.timeSlotBackDetails.amountNumber;
          this.abSlotEstimateCost("", "test");
        }
      }
    },
    onLoadEditDataSet() {
      this.reservationId = this.editReservationDetails.id;
      this.selectedMarker = this.editReservationDetails.station;
      this.selectedChargerValue = this.editReservationDetails.gun;
      if (this.timeSlotBackDetails == null) {
        if (this.editReservationDetails.type.code == "TB") {
          this.timeBase = true;
          this.tbstartTime = new Date(
            this.editReservationDetails.slot.startsOn
          );
          this.tbendTime = new Date(this.editReservationDetails.slot.endsOn);
          this.tbtodayDate = new Date(
            this.editReservationDetails.slot.startsOn
          );
          this.tbEndDate = new Date(this.editReservationDetails.slot.endsOn);
          this.timeSlotEstimateCost("", "test");
        } else {
          this.timeBase = false;
          this.cbstartTime = new Date(
            this.editReservationDetails.slot.startsOn
          );
          this.cbendTime = "-";
          this.cbtodayDate = new Date(
            this.editReservationDetails.slot.startsOn
          );
          this.cbCapacity = this.editReservationDetails.existingQuantity;
          this.cbSlotEstimateCost("", "test");
        }
      } else {
        if (this.timeSlotBackDetails.timeBasedBooking == true) {
          this.timeBase = true;
          this.tbstartTime = new Date(this.timeSlotBackDetails.poststartTime);
          this.tbendTime = new Date(this.timeSlotBackDetails.postendTime);
          this.tbtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
          this.tbEndDate = new Date(this.timeSlotBackDetails.selectedEndDate);
          this.timeSlotEstimateCost("", "test");
        } else {
          this.timeBase = false;
          this.cbstartTime = new Date(this.timeSlotBackDetails.poststartTime);
          this.cbendTime = "-";
          this.cbtodayDate = new Date(this.timeSlotBackDetails.selectedDate);
          this.cbCapacity = this.timeSlotBackDetails.percentNumber;
          this.cbSlotEstimateCost("", "test");
        }
      }
    },
    async confirmPage() {
      try {
        if (this.tbActive) {
          var slotDetails = {
            startTime: this.GetFormattedDate(this.tbstartTime),
            endTime: this.GetFormattedDate(this.tbendTime),
            poststartTime: new Date(this.tbstartTime).toISOString(),
            postendTime: new Date(this.tbendTime).toISOString(),
            estimatedCost: this.estimatedCost,
            selectedDate: this.tbtodayDate,
            selectedEndDate: this.tbEndDate,
            chargeType: EVChargingReservationTypeCode.ChargeForDuration
          };
          
        } else if (this.cbActive) {
          let endTime = new Date(this.cbEndDate);
          endTime.setHours(this.cbendTime.hours);
          endTime.setMinutes(this.cbendTime.minutes);
          var slotDetails = {
            startTime: this.GetFormattedDate(this.cbstartTime),
            // endTime: this.GetFormattedDate(this.cbendTime),
            endTime: this.GetFormattedDate(endTime),
            poststartTime: new Date(this.cbstartTime).toISOString(),
            // postendTime: new Date(this.cbendTime).toISOString(),
            postendTime: new Date(endTime).toISOString(),
            estimatedCost: this.estimatedCost,
            selectedDate: this.cbtodayDate,
            percentNumber: Number(this.cbCapacity),
            chargeType: EVChargingReservationTypeCode.ChargeUptoCapacity
          };
        } else if (this.ubActive) {
          let endTime = new Date(this.ubEndDate);
          endTime.setHours(this.ubendTime.hours);
          endTime.setMinutes(this.ubendTime.minutes);
          
          var slotDetails = {
            startTime: this.GetFormattedDate(this.ubstartTime),
            // endTime: this.GetFormattedDate(this.ubendTime),
            endTime: this.GetFormattedDate(endTime),
            poststartTime: new Date(this.ubstartTime).toISOString(),
            // postendTime: new Date(this.ubendTime).toISOString(),
            postendTime: new Date(endTime).toISOString(),
            estimatedCost: this.estimatedCost,
            selectedDate: this.ubtodayDate,
            unitNumber: Number(this.ubUnit).toFixed(3),
            chargeType: EVChargingReservationTypeCode.ChargeForUnit
          };
        } else if (this.abActive) {
          let endTime = new Date(this.abEndDate);
          endTime.setHours(this.abendTime.hours);
          endTime.setMinutes(this.abendTime.minutes);

          var slotDetails = {
            startTime: this.GetFormattedDate(this.abstartTime),
            // endTime: this.GetFormattedDate(this.abendTime),
            endTime: this.GetFormattedDate(endTime),
            poststartTime: new Date(this.abstartTime).toISOString(),
            // postendTime: new Date(this.abendTime).toISOString(),
            postendTime: new Date(endTime).toISOString(),
            estimatedCost: this.estimatedCost,
            selectedDate: this.abtodayDate,
            amountNumber: Number(this.abAmount).toFixed(2),
            chargeType: EVChargingReservationTypeCode.ChargeForAmount
          };
        }

        localStorage.setItem("slotDetails", JSON.stringify(slotDetails));
        if (this.cbCapacityFlag) {
          localStorage.setItem('duration', JSON.stringify(this.duration))
          this.$router.push("/customer/confirmPage");
        }
      } catch(error) {

      }
      
    },
    blockSpecialChar(evt) {
      var charCode = evt.which ? evt.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    },
    async timeSlotEstimateCost(value, name) {
      if (name == "tbstartTime") {
        var dt = new Date(value);
        this.tbendTime = new Date(dt.setMinutes(dt.getMinutes() + 30));
        //var enddateup = new Date(this.tbEndDate)
        //enddateup = enddateup.setHours(dt.getHours());
        //enddateup=new Date(enddateup)
        //enddateup = enddateup.setMinutes(dt.getMinutes());
        // this.tbEndDate =new Date(enddateup)
        this.tbEndDate = this.tbendTime;
      }
      if (name == "tbtodayDate") {
        var st = new Date(value);
        this.tbtodayDate = st;
        var stTime = new Date(this.tbstartTime);
        stTime = stTime.setMonth(st.getMonth());
        stTime = new Date(stTime);
        stTime = stTime.setDate(st.getDate());
        stTime = new Date(stTime);
        stTime = stTime.setFullYear(st.getFullYear());
        this.tbstartTime = new Date(stTime);
        if (Date.parse(this.tbEndDate) < Date.parse(new Date(value))) {
          this.tbEndDate = new Date(value);
          //var etTimechange = new Date(this.tbtodayDate)
          //this.tbEndDate = new Date(etTimechange.setDate(etTimechange.getDate() + 1))
        }
      }
      if (name == "tbEndDate") {
        if (Date.parse(this.tbtodayDate) > Date.parse(new Date(value))) {
          this.tbEndDate = new Date(this.tbtodayDate);
        } else {
          var et = new Date(value);
          var etTime = new Date(this.tbendTime);
          etTime = etTime.setMonth(et.getMonth());
          etTime = new Date(etTime);
          etTime = etTime.setDate(et.getDate());
          etTime = new Date(etTime);
          etTime = etTime.setFullYear(et.getFullYear());
          this.tbendTime = new Date(etTime);
        }
      }
      if (name == "tbendTime") {
        this.tbendTime = new Date(value);
      }
      this.cbSlotEstimateValue = false;
      this[name] = value;
      var st = new Date(this.tbstartTime);
      var startTimeValue = st.setSeconds(0);
      // the below condition is added for if the time past so we need to reset startTimeValue to current time
     
      // if(this.chargeNow) {
        if(new Date(startTimeValue) < new Date()) {
          startTimeValue = new Date();
          this.tbstartTime = new Date();
        }
      // }
      
      var et = new Date(this.tbendTime);
      var endTimeValue = et.setSeconds(0);

      if (name == "tbendTime" || name == "test") {
        try {
          let data = await new EVCStationReservationService().estimateForChargingOnStationGunBetweenForUserOnExistingReservationIfAny(
            this.selectedChargerValue,
            new Date(startTimeValue).toISOString(),
            new Date(endTimeValue).toISOString(),
            new LocalStorage().user,
            JSON.parse(localStorage.getItem("vehicle")),
            { id: this.reservationId }
          );
          if (data.immediate) {
            this.estimatedCost = data.immediate.cost.toFixed(2);
            this.enableNextSlot = false;
            this.tbSlotEstimateValue = true;
            this.confirmPageNext = false;
            this.chargeNowConfirmPageInd = false
          } else if (data.nextPossible) {
            new ToastUtils().presentToast(
              "Selected time slot not available. Please Choose the Next available slot."
            );
            this.tbSlotEstimateValue = false;
            this.estimatedCost = data.nextPossible.cost.toFixed(2);
            this.enableNextSlot = true;
            this.confirmPageNext = true;
            this.chargeNowConfirmPageInd = true;
            this.nextStartTime = data.nextPossible.slot.startsOn;
            this.nextEndTime = data.nextPossible.slot.endsOn;
          }
        } catch (error) {     
          this.tbSlotEstimateValue = false;
          this.confirmPageNext = true;
          this.chargeNowConfirmPageInd = true;
          // new ToastUtils().presentToast(e.response.data.errors[0].detail);
          let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
        }
      }
    },
    async cbSlotEstimateCost(value, name) {
      if (name == "cbtodayDate") {
        this.cbstartTime = new Date(value);
        this.cbstartTime.setHours(this.cbstartTime.getHours() + 1);
        this.cbSelectedTime = {
          "hours" : this.cbstartTime.getHours(),
          "minutes": this.cbstartTime.getMinutes()
        }
      }
      if(name == "cbstartTime") {
        this.cbSelectedTime = {
          "hours" : value.hours,
          "minutes": value.minutes
        }
        let cbSetStartTime = new Date(this.cbtodayDate);
        cbSetStartTime.setHours(value.hours);
        cbSetStartTime.setMinutes(value.minutes)
        this.cbstartTime = cbSetStartTime;
      }
      
      if(name == "test") {
        let cnDate = new Date(this.cbstartTime);
        this.cbSelectedTime = {
          "hours" : cnDate.getHours(),
          "minutes": cnDate.getMinutes()
        }
      }


// -----------------------------
      this.tbSlotEstimateValue = false;
      // this[name] = value;
      if (isNaN(this.cbCapacity)) {
        new ToastUtils().presentToast(
          "Current Battery Capacity Allow only number"
        );
        this.cbCapacity = "";
      } else {
        try {
          if(moment(this.cbstartTime).format('DD-MM-YYYY') == moment().format('DD-MM-YYYY')) {
            if(new Date(this.cbstartTime) < new Date()) {
              this.cbstartTime = new Date();
            }
          }
          var cbst = new Date(this.cbstartTime);
          var cbstartTimeValue = cbst.setSeconds(0);
          let data = await new EVCStationReservationService().estimateForChargingOnStationGunUptoPercentageForUserOnExistingReservationIfAny(
            this.selectedChargerValue,
            new Date(cbstartTimeValue).toISOString(),
            this.cbCapacity,
            new LocalStorage().user,
            JSON.parse(localStorage.getItem("vehicle")),
            { id: this.reservationId }
          );
          if (data.immediate) {
            this.estimatedCost = data.immediate.cost.toFixed(2);
            let endOn = new Date(data.immediate.slot.endsOn);
            this.cbendTime = {
              "hours" : endOn.getHours(),
              "minutes" : endOn.getMinutes() 
            }
            // this.cbendTime = data.immediate.slot.endsOn;
            this.cbEndDate = data.immediate.slot.endsOn;
            this.enableNextSlot = false;
            this.confirmPageNext = false;
            this.cbSlotEstimateValue = true;
            this.chargeNowConfirmPageInd = false;

            if (name == "cbCapacity") {
              this.cbCapacityFlag = true;
            }
          } else if (data.nextPossible) {
            new ToastUtils().presentToast(
              "Selected time slot not available. Please Choose the Next available slot."
            );
            this.cbSlotEstimateValue = false;
            this.estimatedCost = data.nextPossible.cost.toFixed(2);
            this.enableNextSlot = true;
            this.confirmPageNext = true;
            this.chargeNowConfirmPageInd = true;
            this.nextStartTime = data.nextPossible.slot.startsOn;
            // this.GetFormattedDate(
            //   data.nextPossible.slot.startsOn
            // );
            this.nextEndTime = data.nextPossible.slot.endsOn;
            // this.GetFormattedDate(
            //   data.nextPossible.slot.endsOn
            // );
            if (name == "cbCapacity") {
              this.cbCapacityFlag = true;
            }
          }
        } catch (error) {
          
          this.cbSlotEstimateValue = false;
          this.confirmPageNext = true;
          this.chargeNowConfirmPageInd = true;
          // new ToastUtils().presentToast(e.response.data.errors[0].detail);
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
      }
    },
    async ubSlotEstimateCost(value, name) {
      if (name == "ubtodayDate") {
        this.ubstartTime = new Date(value);
        this.ubstartTime.setHours(this.ubstartTime.getHours() + 1);
        this.ubSelectedTime = {
          "hours" : this.ubstartTime.getHours(),
          "minutes": this.ubstartTime.getMinutes()
        }
      }
      if(name == "ubstartTime") {
        this.ubSelectedTime = {
          "hours" : value.hours,
          "minutes": value.minutes
        }
        let unDate = new Date(this.ubtodayDate);
        unDate.setHours(value.hours);
        unDate.setMinutes(value.minutes);
        this.ubstartTime = unDate;
      } 
      if(name == "test") {
        let unDate = new Date(this.ubstartTime);
        this.ubSelectedTime = {
          "hours" : unDate.getHours(),
          "minutes": unDate.getMinutes()
        }
      }

      this.tbSlotEstimateValue = false;
      // this[name] = value;
      if (isNaN(this.ubUnit)) {
        new ToastUtils().presentToast(
          "Unit To Charge Allow only number"
        );
        this.ubUnit = "";
      } else {
        try {
          if(moment(this.ubstartTime).format('DD-MM-YYYY') == moment().format('DD-MM-YYYY')) {
            if(new Date(this.ubstartTime) < new Date()) {
              this.ubstartTime = new Date();
            }
          }
          var ubst = new Date(this.ubstartTime);
          var ubstartTimeValue = ubst.setSeconds(0);
          let data = await new EVCStationReservationService().estimateForChargingOnStationGunByUnitBasedForUserOnExistingReservationIfAny(
            this.selectedChargerValue,
            new Date(ubstartTimeValue).toISOString(),
            this.ubUnit,
            new LocalStorage().user,
            JSON.parse(localStorage.getItem("vehicle")),
            { id: this.reservationId }
          );
          if (data.immediate) {
            this.estimatedCost = data.immediate.cost.toFixed(2);
            let endOn = new Date(data.immediate.slot.endsOn);
            this.ubendTime = {
              "hours" : endOn.getHours(),
              "minutes" : endOn.getMinutes() 
            }
            // this.ubendTime = data.immediate.slot.endsOn;
            this.ubEndDate = data.immediate.slot.endsOn;
            this.enableNextSlot = false;
            this.confirmPageNext = false;
            this.ubSlotEstimateValue = true;
            this.chargeNowConfirmPageInd = false;
            if (name == "ubUnit") {
              this.ubUnitFlag = true;
            }
          } else if (data.nextPossible) {
            new ToastUtils().presentToast(
              "Selected time slot not available. Please Choose the Next available slot."
            );
            this.ubSlotEstimateValue = false;
            this.estimatedCost = data.nextPossible.cost.toFixed(2);
            this.enableNextSlot = true;
            this.confirmPageNext = true;
            this.chargeNowConfirmPageInd = true;
            this.nextStartTime = data.nextPossible.slot.startsOn;
            // this.GetFormattedDate(
            //   data.nextPossible.slot.startsOn
            // );
            this.nextEndTime = data.nextPossible.slot.endsOn;
            // this.GetFormattedDate(
            //   data.nextPossible.slot.endsOn
            // );
            if (name == "ubUnit") {
              this.ubUnitFlag = true;
            }
          }
        } catch (error) {
          
          this.ubSlotEstimateValue = false;
          this.confirmPageNext = true;
          this.chargeNowConfirmPageInd = true;
          // new ToastUtils().presentToast(e.response.data.errors[0].detail);
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
      }
    },
    async abSlotEstimateCost(value, name) {
      if (name == "abtodayDate") {
        this.abstartTime = new Date(value);
        this.abstartTime.setHours(this.abstartTime.getHours() + 1);
        this.abSelectedTime = {
          "hours" : this.abstartTime.getHours(),
          "minutes": this.abstartTime.getMinutes()
        }
      }
      if(name == "abstartTime") {
        this.abSelectedTime = {
          "hours" : value.hours,
          "minutes": value.minutes
        }
        let anDate = new Date(this.abtodayDate);
        anDate.setHours(value.hours);
        anDate.setMinutes(value.minutes);
        this.abstartTime = anDate;
      } 
      if(name == "test") {
        let anDate = new Date(this.abstartTime);
        this.abSelectedTime = {
          "hours" : anDate.getHours(),
          "minutes": anDate.getMinutes()
        }
      }
      this.tbSlotEstimateValue = false;
      // this[name] = value;
      if (isNaN(this.abAmount)) {
        new ToastUtils().presentToast(
          "Amount To Charge Allow only number"
        );
        this.abAmount = "";
      } else {
        try {
          if(moment(this.abstartTime).format('DD-MM-YYYY') == moment().format('DD-MM-YYYY')) {
            if(new Date(this.abstartTime) < new Date()) {
              this.abstartTime = new Date();
            }
          }
          var abst = new Date(this.abstartTime);
          var abstartTimeValue = abst.setSeconds(0);
          let data = await new EVCStationReservationService().estimateForChargingOnStationGunByAmountBasedForUserOnExistingReservationIfAny(
            this.selectedChargerValue,
            new Date(abstartTimeValue).toISOString(),
            this.abAmount,
            new LocalStorage().user,
            JSON.parse(localStorage.getItem("vehicle")),
            { id: this.reservationId }
          );
          if (data.immediate) {
            this.estimatedCost = data.immediate.cost.toFixed(2);
            let endOn = new Date(data.immediate.slot.endsOn);
            this.abendTime = {
              "hours" : endOn.getHours(),
              "minutes" : endOn.getMinutes() 
            }

            // this.abendTime = data.immediate.slot.endsOn;
            this.abEndDate = data.immediate.slot.endsOn;
            this.enableNextSlot = false;
            this.confirmPageNext = false;
            this.abSlotEstimateValue = true;
            this.chargeNowConfirmPageInd = false;
            if (name == "abAmount") {
              this.abAmountFlag = true;
            }
          } else if (data.nextPossible) {
            new ToastUtils().presentToast(
              "Selected time slot not available. Please Choose the Next available slot."
            );
            this.abSlotEstimateValue = false;
            this.estimatedCost = data.nextPossible.cost.toFixed(2);
            this.enableNextSlot = true;
            this.confirmPageNext = true;
            this.chargeNowConfirmPageInd = true;
            this.nextStartTime = data.nextPossible.slot.startsOn;
            // this.GetFormattedDate(
            //   data.nextPossible.slot.startsOn
            // );
            this.nextEndTime = data.nextPossible.slot.endsOn;
            // this.GetFormattedDate(
            //   data.nextPossible.slot.endsOn
            // );
            if (name == "abAmount") {
              this.abAmountFlag = true;
            }
          }
        } catch (error) {
          
          this.abSlotEstimateValue = false;
          this.confirmPageNext = true;
          this.chargeNowConfirmPageInd = true;
          // new ToastUtils().presentToast(e.response.data.errors[0].detail);
          let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
        }
      }
    },
    formatDate(date) {
      var d = new Date(date);
      var hh = d.getHours();
      var m = d.getMinutes();
      var s = d.getSeconds();
      var dd = "AM";
      var h = hh;
      if (h >= 12) {
        h = hh - 12;
        dd = "PM";
      }
      if (h == 0) {
        h = 12;
      }
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      var pattern = new RegExp("0?" + hh + ":" + m + ":" + s);
      var replacement = h + ":" + m;
      replacement += " " + dd;
      return replacement;
    },
    hourFormat24(data) {
      var date = new Date(data);
      var hour = date.getHours();
      hour = ("0" + hour).slice(-2);
      var Min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
      return hour + ":" + Min;
    },
    GetFormattedDate(data) {
      var date = new Date(data);
      var hour = date.getHours();
      hour = ("0" + hour).slice(-2);
      var Min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
      var monthArry = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var year = date.getFullYear();
      return day + "/" + month + "/" + year + " " + hour + ":" + Min;
    },
    goBack() {
      if (
        localStorage.getItem("vehiclePath") != null &&
        localStorage.getItem("vehiclePath") == "true"
      ) {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/customer/selectVehicle");
      } else {
        this.$router.go(-0);
      }
    },
    tbSlotEstimateCost(time, value) {

      let date = moment.duration(4, 'hours');
      let date1 = new Date(new Date().getTime() + 60 * 60 * 4 * 1000);

    },
    async setHourDuration() {
      let dt = new Date(this.tbstartTime);
      if(this.duration.hour != 0) {
          if(this.duration.minutes != 0) {
            let dateWithMinute = new Date(new Date(dt).getTime() + this.duration.minutes* 60 * 1000);
            let dateWithHourMinute = new Date(dateWithMinute.getTime() + 60 * 60 * this.duration.hour * 1000);
            this.tbendTime = dateWithHourMinute;
          } else {
            let dateWithHour = new Date(new Date(dt).getTime() + 60 * 60 * this.duration.hour * 1000);
            this.tbendTime = dateWithHour;
          }
          
        } else {
          let dateWithMinute = new Date(new Date(dt).getTime() + this.duration.minutes* 60 * 1000);
          this.tbendTime = dateWithMinute;
        }  
    },
    async tbMSlotEstimateCost(value, name) {
      if (name == "tbstartTime") {
        let tbSetTime = new Date(this.tbtodayDate);
        tbSetTime.setHours(value.hours)
        tbSetTime.setMinutes(value.minutes)
        // ****
        this.tbstartTime = tbSetTime;
        // ******
        // var dt = new Date(value);
        var dt = new Date(tbSetTime);
        await this.setHourDuration(); 
      }

      if (name == "tbtodayDate") {
        var st = new Date(value);
        this.tbtodayDate = st;
        var stTime = new Date(this.tbstartTime);
        stTime = stTime.setMonth(st.getMonth());
        stTime = new Date(stTime);
        stTime = stTime.setDate(st.getDate());
        stTime = new Date(stTime);
        stTime = stTime.setFullYear(st.getFullYear());
        this.tbstartTime = new Date(stTime);
        if (Date.parse(this.tbEndDate) < Date.parse(new Date(value))) {
          this.tbEndDate = new Date(value);
        } 
        
        if(Date.parse(this.tbstartTime) > Date.parse(new Date(this.tbendTime))) {
          await this.setHourDuration();
        }
      }
      if(name == 'tbEndTimeHour' || name == 'tbEndTimeMinute') {
        await this.setHourDuration();  
      }
      
      this.cbSlotEstimateValue = false;
      // this[name] = value;
      var st = new Date(this.tbstartTime);
      if(moment(st).format('DD-MM-YYYY') == moment().format('DD-MM-YYYY')) {
        if(st < new Date()) {
          st = new Date();
          this.tbstartTime = st;
          await this.setHourDuration(); 
        }
      }
      var startTimeValue = st.setSeconds(0);
      var et = new Date(this.tbendTime);
      var endTimeValue = et.setSeconds(0);
      if (name == "tbtodayDate" || name == "tbEndTimeHour" || name == "tbEndTimeMinute" || name == 'tbstartTime' || name == 'test') {
        try {
          let data = await new EVCStationReservationService().estimateForChargingOnStationGunBetweenForUserOnExistingReservationIfAny(
            this.selectedChargerValue,
            new Date(startTimeValue).toISOString(),
            new Date(endTimeValue).toISOString(),
            new LocalStorage().user,
            JSON.parse(localStorage.getItem("vehicle")),
            { id: this.reservationId }
          );
          if (data.immediate) {
            this.estimatedCost = data.immediate.cost.toFixed(2);
            this.enableNextSlot = false;
            this.tbSlotEstimateValue = true;
            this.confirmPageNext = false;
            this.chargeNowConfirmPageInd = false;
          } else if (data.nextPossible) {
            new ToastUtils().presentToast(
              "Selected time slot not available. Please Choose the Next available slot."
            );
            this.tbSlotEstimateValue = false;
            this.estimatedCost = data.nextPossible.cost.toFixed(2);
            this.enableNextSlot = true;
            this.confirmPageNext = true;
            this.chargeNowConfirmPageInd = true;
            this.nextStartTime = data.nextPossible.slot.startsOn;
            this.nextEndTime = data.nextPossible.slot.endsOn;
          }
        } catch (error) {
          this.tbSlotEstimateValue = false;
          this.confirmPageNext = true;
          this.chargeNowConfirmPageInd = true;
          let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
        }
      }
    },
    async getAvailableTimeForChargeNow() {
      try {
        let qrCodeValue = localStorage.getItem('qrCodeValue')
        let response = await new EVCStationReservationService().getAvailableTime(qrCodeValue)
        this.confirmPageNext = false;
        this.displayNextChargeTime = false;
        this.enableNextSlot = false;
        if(response.data.startTime) { 
          this.nextChargeTime["startTime"] = response.data.startTime
          this.nextChargeTime["endTime"] = response.data.endTime
          this.displayNextChargeTime = true;
          this.enableNextSlot = false;
        }
        this.reservationId = null;
        this.selectedMarker = JSON.parse(localStorage.getItem("selectedMarker"));
        this.selectedChargerValue = JSON.parse(
          localStorage.getItem("selectedChargerValue")
        );
        this.cbstartTime = new Date();
        this.cbstartTime.setHours(this.cbstartTime.getHours() + 0);
        this.tbendTime = new Date();
        this.tbendTime.setMinutes(this.tbendTime.getMinutes() + 30);

        
        this.tbstartTime = this.cbstartTime;
        this.tbSelectedTime = this.tbstartTime;
        this.cbendTime = "-";
        this.tbEndDate = new Date(this.tbendTime);
        this.tbtodayDate = new Date(this.tbstartTime);

        this.ubstartTime = this.cbstartTime;
        this.ubendTime = "-";
        this.ubEndDate = new Date(this.tbendTime);
        this.ubtodayDate = new Date(this.ubstartTime);

        this.abstartTime = this.cbstartTime;
        this.abendTime = "-";
        this.abEndDate = new Date(this.tbendTime);
        this.abtodayDate = new Date(this.abstartTime);

        // this.tbMSlotEstimateCost("", "test");
        this.abSlotEstimateCost("", "test");
      } catch(error) {
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },
    async chargeNowConfirmPage() {
      if(this.tbActive) {
        if(this.chargeNow) {
          if(this.duration.hour != 0) {
            if(this.duration.minutes != 0) {
              let date = new Date(new Date().getTime() + this.duration.minutes* 60 * 1000);
              let date1 = new Date(date.getTime() + 60 * 60 * this.duration.hour * 1000);
              localStorage.setItem('duration', JSON.stringify(this.duration));
              await this.timeSlotEstimateCost(date1, 'tbendTime');
              if(this.chargeNowConfirmPageInd == false) {
                this.confirmPage();
              }
              
            } else {
              let date1 = new Date(new Date().getTime() + 60 * 60 * this.duration.hour * 1000);
              localStorage.setItem('duration', JSON.stringify(this.duration))
              await this.timeSlotEstimateCost(date1, 'tbendTime');
              if(this.chargeNowConfirmPageInd == false) {
                this.confirmPage();
              }
            }
            
          } else {
            let date = new Date(new Date().getTime() + this.duration.minutes* 60 * 1000);
            localStorage.setItem('duration', JSON.stringify(this.duration))
            await this.timeSlotEstimateCost(date, 'tbendTime');
            if(this.chargeNowConfirmPageInd == false) {
                this.confirmPage();
            }
          }
        } else {
          localStorage.setItem('duration', JSON.stringify(this.duration))
          await this.timeSlotEstimateCost("", "test");
          if(this.chargeNowConfirmPageInd == false) {
              this.confirmPage();
          }
        }
        
      } else if(this.cbActive) {
        await this.cbSlotEstimateCost("", "test")
        if(this.chargeNowConfirmPageInd == false) {
          this.confirmPage();
        }
      } else if(this.ubActive) {
        await this.ubSlotEstimateCost("", "test")
        if(this.chargeNowConfirmPageInd == false) {
          this.confirmPage();
        }
      } else if(this.abActive) {
        await this.abSlotEstimateCost("", "test")
        if(this.chargeNowConfirmPageInd == false) {
          this.confirmPage();
        }
      }
         
    },
    enableNextButto() {
      this.chargeNowConfirmPageInd = false;
    },
    async getCurrentTimeCostEstimate(startTime, chargeType) {
      var st = new Date();
      this.tbstartTime = st;
      if(this.duration.hour != 0) {
        if(this.duration.minutes != 0) {
          let dateWithMinute = new Date(new Date(st).getTime() + this.duration.minutes* 60 * 1000);
          let dateWithHourMinute = new Date(dateWithMinute.getTime() + 60 * 60 * this.duration.hour * 1000);
          this.tbendTime = dateWithHourMinute;
        } else {
          let dateWithHour = new Date(new Date(st).getTime() + 60 * 60 * this.duration.hour * 1000);
          this.tbendTime = dateWithHour;
        }
        
      } else {
        let dateWithMinute = new Date(new Date(st).getTime() + this.duration.minutes* 60 * 1000);
        this.tbendTime = dateWithMinute;
      } 
      var startTimeValue = st.setSeconds(0);
      
      var et = new Date(this.tbendTime);
      var endTimeValue = et.setSeconds(0);
      
      try {
          let data = await new EVCStationReservationService().estimateForChargingOnStationGunBetweenForUserOnExistingReservationIfAny(
            this.selectedChargerValue,
            new Date(startTimeValue).toISOString(),
            new Date(endTimeValue).toISOString(),
            new LocalStorage().user,
            JSON.parse(localStorage.getItem("vehicle")),
            { id: this.reservationId }
          );
          if (data.immediate) {
            this.estimatedCost = data.immediate.cost.toFixed(2);
            this.enableNextSlot = false;
            this.tbSlotEstimateValue = true;
            this.confirmPageNext = false;
            this.chargeNowConfirmPageInd = false;
          } else if (data.nextPossible) {
            new ToastUtils().presentToast(
              "Selected time slot not available. Please Choose the Next available slot."
            );
            this.tbSlotEstimateValue = false;
            this.estimatedCost = data.nextPossible.cost.toFixed(2);
            this.enableNextSlot = true;
            this.confirmPageNext = true;
            this.chargeNowConfirmPageInd = true;
            this.nextStartTime = data.nextPossible.slot.startsOn;
            this.nextEndTime = data.nextPossible.slot.endsOn;
          }
        } catch (e) {
          
          this.tbSlotEstimateValue = false;
          this.confirmPageNext = true;
          this.chargeNowConfirmPageInd = true;
          // new ToastUtils().presentToast(e.response.data.errors[0].detail);
          let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
        }
    },
  },
})
</script>

<style scoped>
.ios ion-icon {
  color: white;
  position: relative;
  left:70%;
}
ion-content {
  --background: #f4f5f9;
  position: absolute;
  --padding-bottom: 200px;
  --padding-top: 54px;
}
.input-box {
      position: relative;
    top: 7.5px;
    width: calc(94% - 11px);
    left: 11px;
    border: 1px solid #ccc;
    outline: none;
    height: 20px;
}
.dp__clear_icon {
  display: none !important;
  color: red !important

}
.time-slot-sec {
  clear: both;
}
 .capacity-sec input {
    border: 1px solid grey !important;
  }
  .capacity-sec input:focus {
    /* margin: 0;
    margin-left: 14px;
    box-shadow: none;
    border: none; */
  }
.ionicon-fill-none {
  color:#21b24b
}
/* Title */
@media (max-width: 768px) {
  .slot-page {
    /* Status bar height on iOS 11.0 */
    top: constant(safe-area-inset-top);
    /* Status bar height on iOS 11+ */
    top: env(safe-area-inset-top);
  }
  .title-add-wrapper .add-wrapper .loc-img {
    margin-right: 13px !important;
  }
  .footer-slot-grid.rp-mobile {
    height: 94px;
  }
  /* .footer-slot-grid.rp-mobile .ft-slot-title p:last-child {
     margin-top: 27px; 
  } */
  .footer-slot-grid.rp-mobile .ft-slot-price p:first-child span {
    display: block;
  }
  .header-toolbar,
  .mobile-header-toolbar {
    --background: #21b24b;
  }

  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }

  .mobile-header-toolbar ion-title {
    color: #fff;
  }

  .mobile-header-toolbar ion-buttons {
    color: #fff;
    --background: #fff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
  .title-add-wrapper,
  .time-detail-wrapper {
    padding-left: 18px !important;
    padding-right: 24px !important;
  }

  .Charging-station-list {
    padding-left: 9px !important;
    padding-right: 6px !important;
  }

  .paddingRight {
    padding-right: 0px !important;
  }
}

@media (min-width: 768px) {
  .title-wrapper .price-tag {
    float: right;
  }

  .title-wrapper .price-tag {
    display: inline-block;
    margin-right: 20px;
    padding-top: 5px;
    padding-bottom: 7px;
  }

  .title-wrapper .price-tag p:first-child,
  .title-wrapper .price-tag p:last-child,
  .title-wrapper ion-title {
    font-family: "Roboto";
    font-size: 15px;
    color: #495057;
  }

  .title-wrapper ion-title {
    padding-top: 10px;
  }

  .title-wrapper .price-tag p:last-child {
    font-family: "Roboto Medium";
  }
}

/* Title */

.fontRobotoBold {
  font-family: "Roboto Bold";
}
.not-available {
  color: red !important;
  font-weight: bold !important;
  color: red !important;
  font-weight: bold !important;
  /* margin-bottom: -5px; */
  margin-top: -5px;
  /* margin-left: 10px; */
  text-align: center;
}
.available-until {
  margin-top: -20px;
}
.until-charger{
  color: #21315d;
  font-weight: bold;
}
.until-chargertime {
  color: #21b24b;
  font-weight: bold;
  border: 0.5px solid #21b24b;
  text-align: center;
}

.fontRobotoMedium {
  font-family: "Roboto Medium";
}

.fontRobotoLight {
  font-family: "Roboto light";
}

.fontRoboto {
  font-family: "Roboto";
}

.clearFix {
  clear: both;
}

.disabledSlot {
  opacity: 0.3;
  pointer-events: none;
}

@media (max-width: 768px) {
  .slot-booking-wrapper .tb-slot {
    min-height: 220px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0000001a;
    padding-top: 18px;
    padding-left: 18px;
    padding-right: 22px;
    margin-top: 10px;
  }

  .slot-booking-wrapper .cb-slot {
    min-height: 255px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0000001a;
    padding-top: 18px;
    padding-left: 18px;
    padding-right: 22px;
    margin-top: 9px;
    margin-bottom: 20px;
  }

  .paddingZero {
    padding: 0px;
  }
}

@media (min-width: 768px) {
  .slot-booking-wrapper {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0000001a;
    opacity: 1;
    margin-top: 12px;
  }
    /* height: 260px;
    padding-top: 10px; */

  .tb-sec-wrapper {
    margin-right: 50px;
  }
}

.tb-header-check ion-label {
  color: #202020;
  opacity: 1;
  font-size: 14px;
  position: relative;
  top: -4px;
}

.tb-header-check ion-radio {
  --border-radius: 50%;
  --border: 3px solid #707070;
  margin-right: 10px;
}

.tb-header-price .title {
  font-size: 14px;
  color: #21315d;
  opacity: 1;
}

.tb-header-price .price {
  font-size: 18px;
  color: #21b24b;
  opacity: 1;
  text-align: right;
}

.width50 {
  width: 50%;
}

.calander-sec {
  padding: 10px;
  position: relative;
  top: 10px;
  height: 140px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 12px;
  opacity: 1;
}

.date-picker-sec {
  /* position: relative; */
  border-bottom: 1px solid #e5e5e5;
}

.date-picker-sec .dp-label {
  /* position: absolute; */
  left: 13px;
  top: 8px;
  /* font-size: 14px; */
}

.date-picker-sec .dp-img {
  /* position: absolute; */
  right: 17px;
  top: 15px;
}

.date-picker-sec ion-datetime {
  padding-left: 12px;
  padding-top: 25px;
  padding-bottom: 8px;
  font-size: 14px;
  font-family: "Roboto";
}
.date-picker-sec VueDatePicker {
  padding-left: 12px;
  padding-top: 25px;
  padding-bottom: 8px;
  font-size: 14px;
  font-family: "Roboto";

}

 .st-slot,
.date-picker-sec:first-child {
  border-right: 1px solid #e5e5e5;
}

 .st-slot,
 .et-slot {
  position: relative;
}

.et-slot.disabledOption,
.date-picker-sec.disabledOption, .st-slot.disabledOption {
  background: #ececec;
  pointer-events: none;
}

.disabledOption {
  background: #ececec;
  pointer-events: none;
}
.disabledChargeType {
    background: #ececec;
    pointer-events: none;
  }
 .st-slot .st-slot-img,
 .et-slot .et-slot-img {
  position: absolute;
  top: 13px;
  right: 14px;
}

 .st-slot span,
 .et-slot span {
  font-size: 14px;
  color: #202020;
  opacity: 1;
  position: relative;
  /* top: 7.5px; */
}

 .st-slot span {
  /* left: 13px; */
}

 .et-slot span {
  left: 11px;
}

 .st-slot ion-datetime,
 .et-slot ion-datetime {
  font-size: 14px;
  color: #202020;
  opacity: 1;
  font-family: "Roboto";
  padding-left: 13px;
}
.st-slot VueDatePicker,
.et-slot VueDatePicker {
  font-size: 14px;
  color: #202020;
  opacity: 1;
  font-family: "Roboto";
  padding-left: 13px;
}

.capacity-sec p,
.capacity-sec input {
  font-size: 14px;
  color: #202020;
  opacity: 1;
}

.capacity-sec p {
  margin-left: 13px;
  margin-top: 7.5px;
}

.capacity-sec {
  border-top: 1px solid #e5e5e5;
}

.capacity-sec input {
  border: none;
  outline: none;
  margin-left: 14px;
}

.calander-sec.cb-based {
  height: 180px;
}

.footer-slot-wrapper {
  position: fixed;
  bottom: 0px;
  width: 100%;
}

.footer-slot-grid {
  height: 77px;
  padding-top: 5px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  opacity: 1;
  padding-top: 15px;
  padding-left: 18px;
  padding-right: 21px;
}

.footer-slot-grid .ft-slot-title p {
  color: #21315d;
  opacity: 1;
  font-size: 15px;
}

.footer-slot-grid .ft-slot-title p:last-child {
  margin-top: 11px;
}

.footer-slot-grid .ft-slot-price p:first-child {
  font-size: 15px;
  color: #202020;
  opacity: 1;
}

.footer-slot-grid .ft-slot-price p:last-child {
  font-size: 18px;
  color: #21b24b;
  opacity: 1;
  text-align: right;
  margin-top: 8px;
}

.next-btn {
  height: 52px;
  --background: #21b24b;
  /* opacity: 1; */
  font-size: 17px;
  color: #ffffff;
  text-transform: uppercase;
  margin: 0;
}

.next-btn img {
  position: absolute;
  right: 24px;
}

.accordion {
  padding: 0;
}
.accor-dion div:not(:last-child) {
  border-bottom: 1px solid rgba(10, 10, 10, 0.1);
}
.accordion div:last-child .accordion-item-details {
  border-radius: 5px;
}
.accordion dd {
  margin-left: 0;
}
.accordion-item-trigger,
.accordion-item-details-inner {
  padding: 0 0.25rem 0.7rem 0.25rem;
}
.accordion-item-title {
  position: relative;
}
.accordion-item-title h4 {
  font-size: 1rem;
  margin-bottom: 0;
  padding-right: 1rem;
  color: #21b24b;
}
.accordion-item-title ion-label {
  font-size: 1rem;
  margin-bottom: 0;
  padding-right: 1rem;
  color: #21b24b;
}

.accordion-item-trigger {
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: none;
}
.accordion-item-trigger-icon {
  display: block;
  position: absolute;
  top: 0;
  right: 1.25rem;
  bottom: 0;
  margin: auto;
  width: 8px;
  height: 8px;
  border-right: 2px solid #363636;
  border-bottom: 2px solid #363636;
  transform: translateY(-2px) rotate(45deg);
  transition: transform 0.2s ease;
}
.is-active .accordion-item-trigger-icon {
  transform: translateY(2px) rotate(225deg);
}
.accordion-item-details {
  overflow: hidden;
  background-color: #f4f5f9;
}
.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
</style>